import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { useNavigate } from 'react-router-dom'
import { useState } from 'react'

import { CheckoutDialog } from '@/credits/components/CheckoutDialog'

import { logout } from '@/api'

import { ArrowLeftStartOnRectangleIcon, CurrencyDollarIcon } from '@heroicons/react/16/solid'
import { useMeQuery } from '@/auth/queries/auth'

import logo from '@/assets/logo.svg'

export const Navigation = () => {
  const navigate = useNavigate()
  const { data: me } = useMeQuery()

  const [isOpen, setIsOpen] = useState(false)

  return (
    <nav className="flex items-center justify-between rounded-full bg-white/5 px-5 py-3 shadow-md">
      <div className="flex items-center gap-1">
        <img src={logo} alt="RecipeVision logo" className="h-10 w-10" />
      </div>
      <Menu>
        <MenuButton className="inline-flex items-center gap-5 rounded-full bg-neutral-800 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-inner shadow-white/10 focus:outline-none data-[focus]:outline-1 data-[focus]:outline-white data-[hover]:bg-neutral-700 data-[open]:bg-neutral-700">
          <div>Credits: {me?.creditBalance}</div>
          <div className="h-6 w-6 rounded-full bg-blue-500 text-white">A</div>
        </MenuButton>
        <MenuItems
          anchor="bottom end"
          transition
          className="mt-2 w-52 origin-top-right rounded-xl border border-white/5 bg-neutral-700 p-1 text-sm/6 text-white transition duration-100 ease-out [--anchor-gap:var(--spacing-1)] focus:outline-none data-[closed]:scale-95 data-[closed]:opacity-0"
        >
          <MenuItem>
            <button
              className="group flex w-full items-center gap-2 rounded-lg px-3 py-1.5 data-[focus]:bg-white/10"
              onClick={() => setIsOpen(true)}
            >
              <CurrencyDollarIcon className="size-4 fill-white/30" />
              Buy credits
            </button>
          </MenuItem>
          <MenuItem>
            <button
              className="group flex w-full items-center gap-2 rounded-lg px-3 py-1.5 data-[focus]:bg-white/10"
              onClick={() => {
                logout()
                navigate('/login')
              }}
            >
              <ArrowLeftStartOnRectangleIcon className="size-4 fill-white/30" />
              Logout
            </button>
          </MenuItem>
        </MenuItems>
      </Menu>
      <CheckoutDialog isOpen={isOpen} setIsOpen={setIsOpen} />
    </nav>
  )
}

export default Navigation
